<template>

  <el-collapse-item name="X轴" title="X轴">
    <el-form-item label="显示">
      <el-switch v-model="ele.option.xAxis.show" active-color="#55aaff"
                 inactive-color="#cfcfcf">
      </el-switch>
    </el-form-item>
    <el-divider></el-divider>
    <el-form-item label="标签">
      <el-switch v-model="ele.option.xAxis.axisLabel.show" active-color="#55aaff"
                 inactive-color="#cfcfcf">
      </el-switch>
    </el-form-item>
    <el-form-item label="标签颜色">
      <el-color-picker v-model="ele.option.xAxis.axisLabel.color"
                       :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']"
                       show-alpha>
      </el-color-picker>
    </el-form-item>

    <el-form-item label="标签间隔">
      <template #label>
        标签间隔
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            默认auto会采用标签不重叠的策略间隔显示标签。<br>
            可以设置成 0 强制显示所有标签。<br>
            如果设置为 1，表示 [隔一个标签显示一个标签] 以此类推<br>

          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-input v-model="ele.option.xAxis.axisLabel.interval" @change="ele.option.xAxis.axisLabel.interval=parseInt(ele.option.xAxis.axisLabel.interval)?
									parseInt(element.option.xAxis.axisLabel.interval):element.option.xAxis.axisLabel.interval">
      </el-input>
    </el-form-item>

    <el-form-item label="标签角度">
      <template #label>
        标签角度
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            刻度标签旋转的角度，显示不下的时候可以通过旋转防止标签之间重叠。<br>旋转的角度从
            -90 度到 90 度。
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-slider v-model="ele.option.xAxis.axisLabel.rotate" :max="90" :min="-90"></el-slider>
    </el-form-item>

    <el-form-item label="标签模板">
      <template #label>
        标签模板
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            使用字符串模板，模板变量为刻度默认标签 {value}
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-input v-model="ele.option.xAxis.axisLabel.formatter"></el-input>
    </el-form-item>

    <el-divider></el-divider>

    <el-form-item label="坐标刻度线">
      <el-switch v-model="ele.option.xAxis.axisTick.show" active-color="#55aaff"
                 inactive-color="#cfcfcf">
      </el-switch>
    </el-form-item>

    <el-form-item label="坐标轴线">
      <el-switch v-model="ele.option.xAxis.axisLine.show" active-color="#55aaff"
                 inactive-color="#cfcfcf">
      </el-switch>
    </el-form-item>

    <el-form-item label="网格分隔线">
      <el-switch v-model="ele.option.xAxis.splitLine.show" active-color="#55aaff"
                 inactive-color="#cfcfcf">
      </el-switch>
    </el-form-item>

  </el-collapse-item>
</template>


<script>
export default {

  props: {
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },

}

</script>

<style scoped lang="scss">

</style>